import { render } from "./HaircolorTreatResult.vue?vue&type=template&id=0233e2b1"
import script from "./HaircolorTreatResult.vue?vue&type=script&lang=js"
export * from "./HaircolorTreatResult.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__